import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `LineaGenetica/getDeleteSeleccion`, method: 'POST', body: {list}, token: token})
}
